import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React, { FC, useMemo, useRef, useState } from 'react';
import { Image } from '../../../components/Image';
import { STYLE_VARS } from '../../../constants/style-vars';
import dayjs from 'dayjs';
import { COLORS, FONTS } from '../../../constants';

interface EventCalendarProps {
  eventDays?: {
    start: string;
    end: string;
    title: string;
  }[];
}

const EventCalendar: FC<EventCalendarProps> = ({ eventDays = [] }) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const getDaysInMonth = (date: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const lastDay = new Date(year, month + 1, 0).getDate();
    return lastDay;
  };
  const renderCalendar = useMemo(() => {
    const daysInMonth = getDaysInMonth(currentDate);
    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const startingDayOfWeek = firstDayOfMonth.getDay();
    // const renderMarkedPeriods = () => {
    //   return eventDays.map((period, index) => {
    //     const { start, end } = period;
    //     const startDate = new Date(start);
    //     const endDate = new Date(end);
    //     const firstDayOfMonth = new Date(
    //       startDate.getFullYear(),
    //       startDate.getMonth(),
    //       1
    //     );
    //     const startOffset = startingDayOfWeek + startDate.getDate() - 1;
    //     const endOffset = startingDayOfWeek + endDate.getDate() - 1;
    //     const startRow = Math.floor(startOffset / 7);
    //     const endRow = Math.floor(endOffset / 7);
    //     const startColumn = startOffset % 7;
    //     const endColumn = endOffset % 7;
    //     const periodStyle = {
    //       left: startColumn * (100 / 7) + '%',
    //       right: (6 - endColumn) * (100 / 7) + '%',
    //       marginTop: startRow * 100 + '%',
    //       marginBottom: (5 - endRow) * 100 + '%',
    //       backgroundColor: STYLE_VARS.primaryColor,
    //     };
    //     console.log(periodStyle);

    //     return (
    //       <View
    //         key={index}
    //         style={[styles.markedPeriod, periodStyle, { zIndex: 10 }]}
    //       />
    //     );
    //   });
    // };

    const calendarDays = [];
    let weekDays = [];

    for (let i = 0; i < startingDayOfWeek; i++) {
      weekDays.push(
        <Text
          key={`empty-day-${i}`}
          style={[styles.dayButton, { backgroundColor: '#e6e6e6' }]}
        />
      );
    }

    for (let i = 1; i <= 7 - startingDayOfWeek; i++) {
      weekDays.push(
        <View key={`calendar-day-${i}`} style={styles.dayButton}>
          <Text style={styles.dayText}>{i}</Text>
        </View>
      );
    }
    calendarDays.push(
      <View style={styles.calendarRow} key={`row-${0}`}>
        {weekDays}
      </View>
    );
    weekDays = [];
    let count = 0;
    for (let i = 7 - startingDayOfWeek + 1; i <= daysInMonth; i++) {
      weekDays.push(
        <View key={`calendar-day-${i}`} style={styles.dayButton}>
          <Text style={styles.dayText}>{i}</Text>
        </View>
      );
      count++;
      if (count === 7) {
        calendarDays.push(
          <View style={styles.calendarRow} key={`row-${i}`}>
            {weekDays}
          </View>
        );
        weekDays = [];
        count = 0;
      }
    }
    if (weekDays.length > 0) {
      const length = 7 - weekDays.length;
      for (let i = 0; i < length; i++) {
        weekDays.push(
          <Text
            key={`empty-day-${i}-end`}
            style={[styles.dayButton, { backgroundColor: '#e6e6e6' }]}
          />
        );
      }
      calendarDays.push(
        <View style={styles.calendarRow} key={`row-end`}>
          {weekDays}
        </View>
      );
    }
    return <View style={styles.calendarContainer}>{calendarDays}</View>;
  }, [currentDate]);

  const handlePreviousMonth = () => {
    const previousMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - 1
    );
    setCurrentDate(previousMonth);
  };

  const handleNextMonth = () => {
    const nextMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1
    );
    setCurrentDate(nextMonth);
  };
  const daysOfWeek = useMemo(() => {
    return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  }, []);

  return (
    <View style={styles.container}>
      <View
        style={{
          paddingHorizontal: 20,
          flexDirection: 'row',
          zIndex: 100,
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 20,
          marginTop: 30,
        }}
      >
        <TouchableOpacity
          style={styles.arrowButton}
          onPress={handlePreviousMonth}
        >
          <Image
            source={require('../../../assets/left-arrow.png')}
            style={styles.arrowStyle}
          />
        </TouchableOpacity>
        <Text
          style={{
            color: STYLE_VARS.textColor,
            fontWeight: '500',
            fontFamily: FONTS.IowanOldStyleBTRoman,
            fontSize: 16,
            lineHeight: 28,
            letterSpacing: 2,
            textTransform: 'uppercase',
            paddingHorizontal: 8,
          }}
        >
          {dayjs(currentDate).format('MMM YYYY')}
        </Text>
        <TouchableOpacity style={styles.arrowButton} onPress={handleNextMonth}>
          <Image
            source={require('../../../assets/right-arrow.png')}
            style={styles.arrowStyle}
          />
        </TouchableOpacity>
      </View>
      <View style={{ flexDirection: 'row', paddingVertical: 10, width: "100%" }}>
        {daysOfWeek.map((day) => (
          <View style={{ flex: 1 }} key={day}>
            <Text
              style={{
                fontFamily: FONTS.AvenirMedium,
                fontSize: 13,
                textTransform: 'uppercase',
                textAlign: 'center',
                color: COLORS.GREEN,
              }}
            >
              {day}
            </Text>
          </View>
        ))}
      </View>
      <View
        style={{
          padding: 2,
          borderRadius: 3,
          borderWidth: 1,
          borderColor: COLORS.GREEN,
          width: '100%',
        }}
      >
        {renderCalendar}
      </View>
    </View>
  );
};

export default EventCalendar;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    marginTop: 20,
  },
  markedPeriod: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    height: 50,
  },
  arrowButton: {
    padding: 5,
  },
  arrowStyle: {
    height: 13,
    width: 10,
    resizeMode: 'contain',
    tintColor: COLORS.GREEN,
  },
  monthButton: {
    fontSize: 20,
    fontWeight: 'bold',
    marginHorizontal: 10,
  },
  monthText: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  calendarContainer: {
    flexDirection: 'column',
  },
  calendarRow: {
    flexDirection: 'row',
    gap: 3,
    marginBottom: 3,
  },
  dayButton: {
    flex: 1,
    height: 100,
    padding: 4,
    borderRadius: 1,
    backgroundColor: COLORS.LIGHT_GREY,
  },
  dayText: {
    fontSize: 13,
    fontFamily: FONTS.AvenirMedium,
    textTransform: 'uppercase',
    color: COLORS.DARK_GREY,
  },
  dayOfWeekText: {
    fontSize: 12,
  },
  emptyDay: {
    width: 40,
    height: 100,
    margin: 5,
  },
});
